import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { closePricingModal } from '../../../../utils/close_modal';
import { useSelector, shallowEqual } from 'react-redux';
import withRouter from '../../../CommonComponents/WithRouter';
import { HideAppsMore, getWallId, getInitialRoute, getNavigate, SOCKET_CONNECTION } from '../../../../utils';
import WallSwitcher from './Components/WallSwitcher';
import { toggleAddFeedsSection_D, toggleAppsMoreSection_D, toggleAutoPilot_D, toggleManageSection_D, togglePhotoBoothUpgrade, toggleThemesSection_D } from '../../../../actions/showDisplayModalAction';
import UpgradeStudio from './UpgradeStudio';
import { AsideMenuStudio } from '../../../Layouts/Main/Studio/_metronic/layout/components/aside/aside-menu/AsideMenu';
import { USER_STUDIO_WALL } from '../../../../actions/sceneActions';
import { useCookies } from 'react-cookie';
import { getWidgetWallData } from '../../../../actions/wallDataAction';
import { updateNewNotification } from '../../../../actions/notificationAction';
import { Button, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '../../../CommonComponents/AssetsHelper';

function AsideMenu(props) {
    const { wallData } = props;
    const [upgradePopup, setUpgradePopup] = useState(false)
    const [isSocialWall, setIsSocialWall] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const wallid = getWallId();
    const [cookies, setCookie, removeCookie] = useCookies(['__ugcupload']);
    const { userfeeds } = useSelector(state => state.analyticwall, shallowEqual);
    const displayMenu = useSelector(state => state.displayModalSection, shallowEqual)
    const userData = useSelector(state => state.authenticated.userData, shallowEqual);
    const route = getNavigate();
    const isPlanExceeded = localStorage.getItem('plan_exceeded');
    const location = useLocation();
    const { pathname } = location;
    const arry = pathname.split("/");
    const currentMenu = arry[arry.length - 1];
    const UserPlan = userData ? userData.UserPlan : {};

    if (localStorage.getItem('isCollaborator') && wallData && wallData?.collaboratorRole) {
        localStorage.setItem('collaboratorRole', wallData.collaboratorRole)
    }

    let collaboratorRole_3 = localStorage.getItem('isCollaborator') != 0 ? (localStorage.getItem('collaboratorRole') == 3) || wallData && wallData.collaboratorId == localStorage.getItem('loginOwnerId') ? wallData?.collaboratorRole == 3 || localStorage.getItem('collaboratorRole') == 3 ? false : true : true : true;
    let collaboratorRole_2 = localStorage.getItem('isCollaborator') != 0 ? (localStorage.getItem('collaboratorRole') == 2) || wallData && wallData.collaboratorId == localStorage.getItem('loginOwnerId') ? wallData?.collaboratorRole == 2 || localStorage.getItem('collaboratorRole') == 2 ? false : true : true : true;

    const handleNavigation = async (route, url) => {
        closePricingModal(dispatch);
        closeModeraionPopups();
        if (route == "addFeeds") { dispatch(toggleAddFeedsSection_D(true)) }
        else if (route == "manageFeeds") { dispatch(toggleManageSection_D(true)) }
        else if (route == "themes") { dispatch(toggleThemesSection_D(true)) }
        else if (route == 'autoPilot') { dispatch(toggleAutoPilot_D(true)) }
        else if (route == 'moderation') { dispatch(toggleAutoPilot_D(false)) }
        else if (route == 'appsMore') { HideAppsMore(true); dispatch(toggleAppsMoreSection_D(true)) }
        else if (route == 'photobooth' && !userData?.UserRule?.photo_booth_upload) { dispatch(togglePhotoBoothUpgrade(true)); return; }
        else{}
        navigate(url);
    }

    const closeModeraionPopups = () => {
        const autoPilot = document.querySelector('.moderation_back');
        if (autoPilot) autoPilot.click();
        setIsSocialWall(false)
    }

    window.handleNavigation = handleNavigation;

    const onClickStudio = () => {
        closePricingModal(dispatch);

        if (userData && Object.keys(userData).length > 0 && userData.UserRule && Object.keys(userData.UserRule).length > 0 && userData.UserRule.studio == 1) {
            dispatch(USER_STUDIO_WALL(wallid))
            navigate(`/studio/${wallid}`);
        } else {
            setUpgradePopup(true)
        }
    }

    const callback = () => {
        setTimeout(() => { handleNavigation(`appsMore`) }, 100);
    }

    const implementNotificationSocket = () => {
        SOCKET_CONNECTION.on('ugcRequest' + localStorage.getItem('wallId'), function (response) {
            if (response && Object.keys(response).length > 0 && response.attr && Object.keys(response.attr).length > 0 && response.attr.created) {
                dispatch(updateNewNotification({ type: "notifysync", synced: 0, created: response.attr.created, page: 0, perPage: 10, sortby: "message", direction: "ASC" }));
            }
        });
    }

    useEffect(() => {
        if (wallid && !isNaN(wallid)) {
            implementNotificationSocket();
            if (window.location.href.includes('?manage-feed=true')) handleNavigation('manageFeeds', `/wall/index/${wallid}`)
        }
    }, [wallid])


    useEffect(() => {
        window.onload = function () {
            if (cookies && cookies.__ugcupload && cookies.__ugcupload == '__ugcupload') getWidgetWallData(localStorage.getItem('ownerId'), wallid, callback())
        }
    }, [displayMenu]);

    return <div className="aside-menu h-100">
        <div id="kt_aside_menu" className='overflow-y-auto overflow-x-hidden'>
            <WallSwitcher prefix={props.prefix} userfeeds={userfeeds} UserPlan={UserPlan} />

            {String(arry).toLowerCase().includes("studio") ? <AsideMenuStudio {...props} /> : <Nav className="menu-nav p-0 m-0">
                {!isPlanExceeded && <Nav.Link className='menu-item' onClick={() => handleNavigation(`home`, `${JSON.parse(localStorage.getItem('isCollaborator')) == 0 ? '/walls/home' : '/walls'}`)}>
                    <FontAwesomeIcon type={'regular'} icon={'house'} />
                    <span className="menu-text ms-2">Home</span>
                </Nav.Link>}


                {isPlanExceeded && <Nav.Link href={`/walls`} className={`menu-item ${currentMenu == "walls" ? "menu-item-active bg-light" : ""}`} onClick={() => closePricingModal(dispatch)}>
                    <FontAwesomeIcon type={'regular'} icon={'clone'} />
                    <span className="menu-text ms-2">My Walls</span>
                </Nav.Link>}

                {!isPlanExceeded && collaboratorRole_3 ? <div className={`w-100 menu-item-submenu ${isSocialWall || (window.location.href.includes('wall/index/') && (displayMenu.showAddFeedD || displayMenu.showManageFeedD)) ? "menu-item-active menu-item-open bg-light" : ""}`} onClick={()=>setIsSocialWall(!isSocialWall)}>
                    <Nav.Link className="menu-item menu-toggle">
                        <FontAwesomeIcon type={'regular'} icon={'layer-plus'} />
                        <span className="menu-text flex-grow-1 ms-2">Social Feeds</span> <FontAwesomeIcon type={'regular'} icon={'angle-right'} iconClass={'menu-arrow'} />
                    </Nav.Link>
                    <div className="menu-submenu ps-4">
                        <Nav.Link className={`menu-item fw-normal  ${displayMenu.showAddFeedD == true ? 'menu-item-active' : ''}`} id="addFeed" onClick={() => handleNavigation(`addFeeds`, `/wall/index/${wallid}`)}>
                            <FontAwesomeIcon type={'solid'} icon={'circle'} iconClass={`fs-10 ${displayMenu.showAddFeedD == true ? 'text-gradient' : 'text-gray-500'}`} />
                            <span className="menu-text ms-2"> Add Feed </span>
                        </Nav.Link>
                        <Nav.Link className={`menu-item fw-normal  ${displayMenu.showManageFeedD == true ? 'menu-item-active' : ''}`} id="manageFeed" onClick={() => handleNavigation(`manageFeeds`, `/wall/index/${wallid}`)}>
                            <FontAwesomeIcon type={'solid'} icon={'circle'} iconClass={`fs-10 ${displayMenu.showManageFeedD == true ? 'text-gradient' : 'text-gray-500'}`} />
                            <span className="menu-text ms-2">Manage Feeds</span>
                        </Nav.Link>
                    </div>
                </div> : null}

                {collaboratorRole_3 ?  <Nav.Link className={`w-100 menu-item li-list snapup-lin ${window.location.href.includes('wall/snapup') ? 'menu-item-active' : ''}`} aria-haspopup="true" onClick={() => handleNavigation('snapup', `/wall/snapup/${wallid}`)}>
                    <FontAwesomeIcon type={'regular'} icon={'fa-brands fa-onsite-upload fab'} />
                    <span className="menu-text ms-2">SnapUp</span>
                </Nav.Link>
                        : null}

                {String(props.prefix).toLowerCase().includes("socialwalls") && (collaboratorRole_2 && collaboratorRole_3) ? <Nav.Link className={`li-list menu-item ${pathname.includes('wall/personalize') ? 'menu-item-active' : ''}`} onClick={() => handleNavigation(`personalization`, `/wall/personalize/${wallid}`)} aria-haspopup="true">
                    <FontAwesomeIcon type={'regular'} icon={'fill-drip'} />
                    <span className="menu-text ms-2">Personalize</span>
                </Nav.Link> : null}

                {collaboratorRole_3 ? <Nav.Link className={`w-100 li-list menu-item ${route == "studio" ? 'menu-item-active' : ''}`} onClick={() => onClickStudio()}>
                    <FontAwesomeIcon type={'regular'} icon={'display'} />
                    <span className="menu-text ms-2">Studio</span>
                </Nav.Link> : null}

                <div className={`w-100 menu-item-submenu moderation-item-open ${window.location.href.includes('moderation') ? 'menu-item-active active bg-light' : ''}`}>
                    <Nav.Link className="menu-item menu-toggle" onClick={() => handleNavigation('moderation', `/moderation/index/${wallid}`)}>
                        <FontAwesomeIcon type={'regular'} icon={'check-to-slot'} />
                        <span className="menu-text ms-2">Moderation</span>
                    </Nav.Link>
                    <div className="menu-submenu d-block ps-4">
                        <Nav.Link className={`menu-item ${(window.location.href.includes('moderation') && !displayMenu?.showAutoPilotD) ? 'menu-item-active' : ''}`} onClick={() => handleNavigation('moderation', `/moderation/index/${wallid}`)}>
                            <FontAwesomeIcon type={'solid'} icon={'circle'} iconClass={`fs-10 ${(window.location.href.includes('moderation') && !displayMenu?.showAutoPilotD) ? 'text-gradient' : 'text-gray-500'}`} />
                            <span className="menu-text ms-2">Manual</span>
                        </Nav.Link>
                        <Nav.Link id="initCustomiztion" className={`menu-item ${(displayMenu?.showAutoPilotD) ? 'menu-item-active' : ''}`} onClick={() => handleNavigation('autoPilot', `/moderation/index/${wallid}`)}>
                            <FontAwesomeIcon type={'solid'} icon={'circle'} iconClass={`fs-10 ${(displayMenu?.showAutoPilotD) ? 'text-gradient' : 'text-gray-500'}`} />
                            <span className="menu-text ms-2">Auto Pilot 
                                {/* <span className="new-tag ms-2">New</span> */}
                            </span>
                        </Nav.Link>
                    </div>
                </div>

                <Nav.Link className={`w-100 menu-item li-list photoBooth-lin ${window.location.href.includes('wall/photobooth') ? 'menu-item-active' : ''}`} aria-haspopup="true" onClick={() => handleNavigation('photobooth', `/wall/photobooth/${wallid}`)}>
                    <FontAwesomeIcon type={'regular'} icon={'camera-retro'} />
                    <span className="menu-text ms-2">Photo Booth <span className="new-tag ms-2">New</span></span>
                </Nav.Link>

                <Nav.Link className={`w-100 menu-item li-list truSense-lin ${window.location.href.includes('trusense') ? 'menu-item-active' : ''}`} aria-haspopup="true" onClick={() => handleNavigation('trusense', `/wall/trusense/${wallid}`)}>
                    <FontAwesomeIcon type={'regular'} icon={'sparkles'} />
                    <span className="menu-text ms-2">TruSense 
                        {/* <span className="new-tag ms-2">New</span> */}
                    </span>
                </Nav.Link>


                {(getInitialRoute() != 'display' || isPlanExceeded) && collaboratorRole_2 && collaboratorRole_3 ? <Nav.Link className={`w-100 li-list menu-item ${pathname.includes('/analytic') ? 'menu-item-active' : ''}`} onClick={() => handleNavigation('analytic', `${![58].includes(UserPlan.planId) ? '/analytic/' : '/analytic/'}${wallid}`)} id="" aria-haspopup="true">
                    <FontAwesomeIcon type={'regular'} icon={'chart-simple'} />
                    <span className="menu-text ms-2">Analytics </span>
                </Nav.Link> : null}

                {!isPlanExceeded && collaboratorRole_2 && collaboratorRole_3 ? <Nav.Link className={`w-100 li-list menu-item ${displayMenu.showAppsMoreD == true ? 'menu-item-active' : ''}`} id='apps-more' onClick={() => handleNavigation('appsMore',`/wall/index/${wallid}`)} aria-haspopup="true">
                    <FontAwesomeIcon type={'regular'} icon={'grid-2-plus'} iconClass={'rotatex-180'} />
                    <span className="menu-text ms-2">Apps & More</span>
                </Nav.Link> : null}
            </Nav>
            }
        </div>

        {!isPlanExceeded && (collaboratorRole_2 && collaboratorRole_3) ? <div className="sidebar_action p-3">

            {!isPlanExceeded && <Button variant='primary' onClick={() => handleNavigation(`publish`, `/wall/preview/${wallid}`)} id="initPublishPopupId" className="w-100 py-3 fs-6 text-uppercase">
                <FontAwesomeIcon type={'regular'} icon={'code'} iconClass={"fs-4"} />
                <span>Display</span>
            </Button>}
        </div> : null}
        {upgradePopup ? <UpgradeStudio open={true} onHide={() => setUpgradePopup(false)} /> : null}
    </div>
}

export default withRouter(React.memo(AsideMenu));